import {Routes} from '@angular/router';
import {AuthenticationGuard, AuthorizationGuard} from '@softline/auth';
import {importProvidersFrom} from '@angular/core';
import {
  ConnectionHttpService,
  SOFTLINE_SERVICE_HTTP,
  SOFTLINE_STORE_ENTITY_SERVICE,
  SoftlineEntityService,
  StoreModule
} from '@softline/core';
import {
  HardwareManagementBetriebssystemStore,
  HardwareManagementCommentsStore,
  HardwareManagementGarantietypStore,
  HardwareManagementHerstellerStore,
  HardwareManagementKtostammStandortStore,
  HardwareManagementProdukteStore,
  HardwareManagementStore,
  HardwareManagementSubnetzmaskeStore,
  HardwareManagementSupporttypStore,
  HardwareManagementTypStore,
  SOFTLINE_FEATURE_HARDWARE_MANAGEMENT,
  SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_BETRIEBSSYSTEM,
  SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_COMMENTS,
  SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_GARANTIETYP,
  SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_HERSTELLER,
  SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_KTOSTAMM_STANDORT,
  SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_PRODKUTE,
  SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_SUBNETZMASKE,
  SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_SUPPORTTYP,
  SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_TYP,
  SOFTLINE_PERMISSION_HARDWARE_MANAGEMENT
} from './hardware-management.shared';
import {
  SOFTLINE_API_HARDWARE_MANAGEMENT_BETRIEBSSYSTEME,
  SOFTLINE_API_HARDWARE_MANAGEMENT_COMMENTS,
  SOFTLINE_API_HARDWARE_MANAGEMENT_GARANTIETYPEN,
  SOFTLINE_API_HARDWARE_MANAGEMENT_HERSTELLER,
  SOFTLINE_API_HARDWARE_MANAGEMENT_LISTE,
  SOFTLINE_API_HARDWARE_MANAGEMENT_PRODUKTE,
  SOFTLINE_API_HARDWARE_MANAGEMENT_SUBNETZMASKEN,
  SOFTLINE_API_HARDWARE_MANAGEMENT_SUPPORTTYPEN,
  SOFTLINE_API_HARDWARE_MANAGEMENT_TYPEN
} from './hardware-management.api';
import { SOFTLINE_STORE_FIELD_OK_NAME } from '@softline/dynamic';
import { FieldOkService, SOFTLINE_STORE_FIELD_OK_SERVICE } from '@softline/dynamic';

export const hardwareRoutes: Routes = [
  {
    path: 'hardware-management',
    loadComponent: () => import('./pages/hardware-management.component').then(o => o.HardwareManagementComponent),
    children: [
      {path: 'create', loadComponent: () => import('./pages/create/create.component').then(o => o.CreateComponent)},
      {path: 'search', loadComponent: () => import('./pages/search/search.component').then(o => o.SearchComponent)},
      {path: ':id', loadComponent: () => import('./pages/results/results.component').then(o => o.ResultsComponent)},
      {path: '', loadComponent: () => import('./pages/results/results.component').then(o => o.ResultsComponent), pathMatch: 'full'},
      {path: '**', redirectTo: '/hardware-management' },
    ],
    canActivate: [AuthenticationGuard, AuthorizationGuard],
    data: {permission: SOFTLINE_PERMISSION_HARDWARE_MANAGEMENT},
    providers: [
      importProvidersFrom(
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_HARDWARE_MANAGEMENT,
          feature: HardwareManagementStore.feature,
          providers: [
            {
              provide: SOFTLINE_STORE_ENTITY_SERVICE,
              useFactory: (service: ConnectionHttpService) => new SoftlineEntityService(service, SOFTLINE_API_HARDWARE_MANAGEMENT_LISTE),
              deps: [SOFTLINE_SERVICE_HTTP]
            }
          ]
        }),
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_PRODKUTE,
          feature: HardwareManagementProdukteStore.feature,
          providers: [
            {
              provide: SOFTLINE_STORE_ENTITY_SERVICE,
              useFactory: (service: ConnectionHttpService) => new SoftlineEntityService(service, SOFTLINE_API_HARDWARE_MANAGEMENT_PRODUKTE),
              deps: [SOFTLINE_SERVICE_HTTP]
            }
          ]
        }),
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_TYP,
          feature: HardwareManagementTypStore.feature,
          providers: [
            {
              provide: SOFTLINE_STORE_ENTITY_SERVICE,
              useFactory: (service: ConnectionHttpService) => new SoftlineEntityService(service, SOFTLINE_API_HARDWARE_MANAGEMENT_TYPEN),
              deps: [SOFTLINE_SERVICE_HTTP]
            }
          ]
        }),
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_BETRIEBSSYSTEM,
          feature: HardwareManagementBetriebssystemStore.feature,
          providers: [
            {
              provide: SOFTLINE_STORE_ENTITY_SERVICE,
              useFactory: (service: ConnectionHttpService) => new SoftlineEntityService(service, SOFTLINE_API_HARDWARE_MANAGEMENT_BETRIEBSSYSTEME),
              deps: [SOFTLINE_SERVICE_HTTP]
            }
          ]
        }),
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_GARANTIETYP,
          feature: HardwareManagementGarantietypStore.feature,
          providers: [
            {
              provide: SOFTLINE_STORE_ENTITY_SERVICE,
              useFactory: (service: ConnectionHttpService) => new SoftlineEntityService(service, SOFTLINE_API_HARDWARE_MANAGEMENT_GARANTIETYPEN),
              deps: [SOFTLINE_SERVICE_HTTP]
            }
          ]
        }),
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_HERSTELLER,
          feature: HardwareManagementHerstellerStore.feature,
          providers: [
            {
              provide: SOFTLINE_STORE_ENTITY_SERVICE,
              useFactory: (service: ConnectionHttpService) => new SoftlineEntityService(service, SOFTLINE_API_HARDWARE_MANAGEMENT_HERSTELLER),
              deps: [SOFTLINE_SERVICE_HTTP]
            }
          ]
        }),
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_SUBNETZMASKE,
          feature: HardwareManagementSubnetzmaskeStore.feature,
          providers: [
            {
              provide: SOFTLINE_STORE_ENTITY_SERVICE,
              useFactory: (service: ConnectionHttpService) => new SoftlineEntityService(service, SOFTLINE_API_HARDWARE_MANAGEMENT_SUBNETZMASKEN),
              deps: [SOFTLINE_SERVICE_HTTP]
            }
          ]
        }),
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_SUPPORTTYP,
          feature: HardwareManagementSupporttypStore.feature,
          providers: [
            {
              provide: SOFTLINE_STORE_ENTITY_SERVICE,
              useFactory: (service: ConnectionHttpService) => new SoftlineEntityService(service, SOFTLINE_API_HARDWARE_MANAGEMENT_SUPPORTTYPEN),
              deps: [SOFTLINE_SERVICE_HTTP]
            }
          ]
        }),
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_KTOSTAMM_STANDORT,
          feature: HardwareManagementKtostammStandortStore.feature,
          providers: [
            {
              provide: SOFTLINE_STORE_FIELD_OK_SERVICE,
              useFactory: (service) => new FieldOkService<any, any, any>(service, 'ktostamm.kunde.subnummer'),
              deps: [ConnectionHttpService]
            }
          ]
        }),
        StoreModule.forFeature({
          name: SOFTLINE_FEATURE_HARDWARE_MANAGEMENT_COMMENTS,
          feature: HardwareManagementCommentsStore.feature,
          providers: [
            {
              provide: SOFTLINE_STORE_ENTITY_SERVICE,
              useFactory: (service: ConnectionHttpService) => new SoftlineEntityService(service, SOFTLINE_API_HARDWARE_MANAGEMENT_COMMENTS),
              deps: [SOFTLINE_SERVICE_HTTP]
            }
          ]
        }),
      ),
    ]
  },
];
